module.exports = __webpack_public_path__ + "img/hyal-8@2x.38a7d693.png";